import { IconButton } from "@mui/material"
import styles from "./styles"
import { css } from "aphrodite";


const CustomRectangleIconButton = ({
    iconSrc,
    onClick = () => {},
    ariaLabel,
    "aria-label": ariaLabelAttr,
}) => {
    const resolvedAriaLabel = ariaLabel || ariaLabelAttr;

    return (
        <IconButton 
            onClick={onClick}
            className={css(styles.button)}
            variant="contained"
            color="primary"
            aria-label={resolvedAriaLabel}
        >
            <img src={iconSrc} alt="" />
        </IconButton>
    )
}

export default CustomRectangleIconButton
